import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { MdtGuardService } from './mdt-guard.service';

export const canDeactivateMdt: CanDeactivateFn<any> = () => {
  return inject(MdtGuardService).canDeactivate();
};
